import { Button } from "@/components/ui/button"
import {
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog"
import { Form, FormField } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { BodyMedium, H3, Small } from "@/components/ui/typography"
import { VehicleModel, vehicleSchema } from "@/state/draft/vehicle"
import { zodResolver } from "@hookform/resolvers/zod"
import React from "react"
import { useForm } from "react-hook-form"

type AddVehicleDialogProps = {
	onSubmit: (vehicle: VehicleModel) => void
	vehicle?: VehicleModel
	submiting?: boolean
}

export const AddVehicleDialogContent: React.FC<AddVehicleDialogProps> = (props) => {
	const form = useForm<VehicleModel>({
		resolver: zodResolver(vehicleSchema),
		defaultValues: props.vehicle,
	})

	const handleSubmit = (data: VehicleModel) => {
		props.onSubmit(data)
	}

	return (
		<DialogContent closeVisible>
			<DialogHeader>
				<DialogTitle>
					<H3>Add Vehicle</H3>
				</DialogTitle>
			</DialogHeader>
			<Form {...form}>
				<form
					className="flex flex-col gap-4"
					onSubmit={form.handleSubmit(handleSubmit)}
				>
					<FormField
						control={form.control}
						name="make"
						render={({ field }) => (
							<div>
								<Label htmlFor="make">Make</Label>
								<Input id="make" className="h-12" {...field} />
								{form.formState.errors.make && (
									<Small className="text-destructive">
										{form.formState.errors.make.message}
									</Small>
								)}
							</div>
						)}
					/>
					<FormField
						control={form.control}
						name="model"
						render={({ field }) => (
							<div>
								<Label htmlFor="model">Model</Label>
								<Input id="model" className="h-12" {...field} />
								{form.formState.errors.model && (
									<Small className="text-destructive">
										{form.formState.errors.model.message}
									</Small>
								)}
							</div>
						)}
					/>

					<FormField
						control={form.control}
						name="year"
						render={({ field }) => (
							<div>
								<Label htmlFor="year">Year</Label>
								<Input
									id="year"
									className="h-12"
									type="number"
									{...field}
								/>
								{form.formState.errors.year && (
									<Small className="text-destructive">
										{form.formState.errors.year.message}
									</Small>
								)}
							</div>
						)}
					/>

					<Button
						disabled={props.submiting}
						className="mt-4 text-primary-foreground"
						type="submit"
					>
						{props.submiting ? "Saving" : "Save"}
					</Button>
				</form>
			</Form>
		</DialogContent>
	)
}
